import * as yup from 'yup';

export const NewPasswordSchema = yup.object({
	oldPassword: yup.string().default(''),
	password: yup
		.string()
		.required('Password is required')
		.matches(
			/(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,}$/,
			'Password must contain at least 8 characters, 1 uppercase, 1 lowercase, and 1 number.'
		),
	confirmPassword: yup
		.string()
		.required('Confirm Password is required')
		.oneOf([yup.ref('password')], 'Passwords must match'),
});

export type NewPasswordSchemaType = yup.InferType<typeof NewPasswordSchema>;

export const loginPasswordRules = [
	{ label: 'Minimum of 8 characters', pattern: new RegExp(/.{8,}$/) },
	{ label: 'At least 1 uppercase', pattern: new RegExp(/.*[A-Z]/) },
	{ label: 'At least 1 lowercase', pattern: new RegExp(/[a-z]/) },
	{ label: 'At least 1 number', pattern: new RegExp(/.*\d/) },
];

export interface IFormNewPassword {
	onSuccess?: () => void;
	onRejected?: (reason: unknown) => void | PromiseLike<void>;
	type: 'change' | 'reset';
}

export interface IValidationCheck {
	item: string;
	success?: boolean;
}
